import { define, prop } from "@/components/builder/utils";

import { useCraftCustom } from "../../core/hooks";

import { useRegisterConditionalCase } from "./context";

function ConditionalCasePreview({ children }) {
  return children
}

function ConditionalCaseHTML({ children }) {
  if (!children?.length) return null

  return children
}

function ConditionCaseWrapper({ children }) {
  useRegisterConditionalCase()
  return children
}

export default define('conditional-case', ConditionalCasePreview, ConditionalCaseHTML)
  .name('case')
  .wrap(({ children }) => {
    const { value: state } = useCraftCustom('state')

    if (!state) {
      return children
    }

    return <ConditionCaseWrapper>
      {children}
    </ConditionCaseWrapper>
  })
  .property(prop.text('Condition', 'condition').category('default').ignoreDevice(true).blockClear().own().props({ disabled: true }))
  .build()
